import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../Edit/Store';
import { SectionContext } from '../../../Types';
import Modal from '../../../Modal';
import ExperienceCatalogModalState from './ExperienceCatalogModalState';
import Header from './Header';
import Store from './Store';
import { LearningCollectionEditFormResource } from '../../../Edit/Store/Types';

export interface Props {
  store: Store;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const ExperienceCatalogModal: React.FC<Props> = ({
  store,
  learningDesignName,
  learningCollectionStore,
  context,
  learningCollectionEditFormResource,
}) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'waiting-with-link':
    case 'hiding':
      return <></>;
    case 'loading':
    case 'loading-error':
    case 'showing':
    case 'selecting':
      return (
        <Modal
          close={store.closeModal}
          title={<Header />}
          modalWidth="h-4/5 w-4/5 min-h-[400px] max-h-[90vh] overflow-y-auto"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <ExperienceCatalogModalState
            store={store}
            learningDesignName={learningDesignName}
            learningCollectionStore={learningCollectionStore}
            context={context}
            learningCollectionEditFormResource={learningCollectionEditFormResource}
          />
        </Modal>
      );
  }
};

export default observer(ExperienceCatalogModal);
